<template>
  <div class="modal-overlay">
    <div class="modal-container">
      <div class="modal-content">
        <div class="w-full flex flex-col p-2 bg-white shadow-lg rounded-lg">
          <x-icon class="cancel_btn" @click="cancel" />
          <h3 class="self-center">DOT INSPECTION DAYS</h3>
          <div class="p-6">

            <div class="grid grid-cols-4 gap-4 content-around mb-6">
              <div>
                <label class="block text-gray-700 mb-1">Driver</label>
                <v-select v-model="selectedDriver" :options="drivers" placeholder="Select Driver" />
              </div>

              <div>
                <label class="block text-gray-700 mb-1">Year</label>
                <v-select v-model="selectedYear" :options="years" placeholder="Select Year" />
              </div>

              <div>
                <label class="block text-gray-700 mb-1">Month</label>
                <v-select v-model="selectedMonth" :options="months" placeholder="Select Month" />
              </div>

              <div class="flex">
                <vs-button class="w-full self-end" @click="handleSubmit">Submit</vs-button>
              </div>
            </div>

            <div v-if="daysInfo.length" v-for="(item, idx) in daysInfo" :key="idx" class="flex flex-col gap-6">
              <div
                :class="(idx % 2 === 0 ? 'bg-grey-light flex justify-between py-3 px-2' : 'flex justify-between py-3 px-2')">
                <div class="flex gap-6">
                  <p>DOT DAY: </p>
                  <span>{{ item.processed_time }}</span>
                </div>
                <vs-button class="bg-green text-white px-3 py-2 rounded-sm">view</vs-button>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { XIcon } from 'vue-feather-icons';
import vSelect from 'vue-select';
import 'vue2-datepicker/index.css'; // Import CSS for styling

export default {
  components: { vSelect, XIcon },
  data() {
    return {
      selectedDriver: null,
      selectedYear: null,
      selectedMonth: null,
      years: Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i),
      months: [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December',
      ]
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    handleSubmit() {
      const query = {
        month: this.selectedMonth && this.selectedMonth,
        year: this.selectedYear && this.selectedYear,
        name: this.selectedDriver && this.selectedDriver.value,
      }
      this.$store.dispatch('fmcsaReports/fetchDays', query)
    },
  },
  computed: {
    drivers() {
      return this.$store.state.fmcsaReports.drivers
    },
    daysInfo() {
      return this.$store.state.fmcsaReports.daysInfo
    }
  },

}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  z-index: 1000;
  opacity: 0;
  animation: fadeIn 0.3s forwards;
}


::v-deep .custom-multiple-select .vs__selected-options {
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;
}

.cancel_btn {
  position: absolute;
  right: 15px;
}

::v-deep .custom-multiple-select .vs__selected-options::-webkit-scrollbar {
  height: 2px;
}

::v-deep .custom-multiple-select .vs__selected-options::-webkit-scrollbar-thumb {
  background-color: #a0a0a0;
  /* Color of the scrollbar thumb */
  border-radius: 0px;
}

::v-deep .custom-multiple-select .vs__selected-options::-webkit-scrollbar-track {
  background-color: #f0f0f0;
  /* Color of the scrollbar track */
}

.modal-container {
  position: relative;
  top: 7%;
  width: 100%;
  max-width: 80dvw;
  border-radius: 8px;
  transform: translateY(-100%);
  animation: slideIn 0.5s forwards ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes slideIn {
  from {
    transform: translateY(-100%);
  }

  to {
    transform: translateY(0);
  }
}
</style>
